<svg
	width="100%"
	height="100%"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="2"
	stroke-linecap="round"
	stroke-linejoin="round"
	><line x1="12" y1="19" x2="12" y2="5"></line><polyline
		points="5 12 12 5 19 12"
	></polyline></svg
>
